import { withAppCrashIfException } from 'epic';
import { mailStatusEpic } from 'epic/notification/mailStatus/mailStatus';
import { combineEpics } from 'redux-observable';

import { sessionEpic } from './session/sessionEpic';

export const notificationEpic = () =>
  combineEpics(
    withAppCrashIfException('sessionEpic', sessionEpic()),
    withAppCrashIfException('mailStatusEpic', mailStatusEpic()),
  );
